
import React, { useRef, useCallback, useEffect } from 'react';
/**
 * 获取文件名后缀
 * @param str string 文件名
 * @returns string 文件名后缀(文件类型)
 */
function getSuffixName(str:string){
    console.error("str", str)
    let arr = str.split('.')
    return arr[arr.length - 1]
}

function query2Obj(url:string){
  return Object.fromEntries(
      decodeURI(url)
      .split('?')[1]
      .split('&')
      .map(it=>{ 
          return it.split('=').map(item=>decodeURIComponent(item))
      })
  )
}
// 人员选择器
const memberDialog = (cb) => {
  const memberSelector = sdk.components?.memberSelectorModal
  let destory: any;
  destory = memberSelector?.render(
    {
      visible: true,
      from:'AreaPermission',
      handleClose: () => {
        console.log('destory')
        destory()
      },
      handleSubmit: (target: any, newFileName?: string) => {
        // console.log(target, newFileName)
        cb(target)
      }
    }
  )
}
// flat
function createRoutes(arr:any[]){
  if(!arr.length) return arr
  let container:any[] = []
  arr.forEach(l=>{
    if(l.children){
      container.push({...l, children: null})
      container = [...container.concat(createRoutes(l.children))]
    }else{
      container.push(l)
    }
  })
  return container
}
function format24Hours(t:any){
  
  const hours = t.hours().toString().padStart(2, "0")
  const minutes = t.minutes().toString().padStart(2, "0")
  return `${hours}:${minutes}`
}

function _debounce(){
  let t
  return function (cb,delay){
    console.log("t", t)
    if(!t){
      t = setTimeout(cb,delay)
    }else{
      clearTimeout(t)
      t = setTimeout(cb,delay)
    }
  }
}
function useDebounce(fn, delay) {
  const timer = useRef<null|number>(null);
 
  const cancel = useCallback(() => {
    if (timer.current) {
      clearTimeout(timer.current);
    }
  }, []);
 
  const debounced = useCallback((...args) => {
    cancel();
    timer.current = setTimeout(() => {
      fn(...args);
    }, delay);
  }, [cancel, fn, delay]);
 
  useEffect(() => {
    return () => {
      cancel();
    };
  }, [cancel]);
 
  return debounced;
}

export {
    getSuffixName,
    query2Obj,
    memberDialog,
    createRoutes,
    format24Hours,
    useDebounce
}